<main id="maincontent" role="main">
  <section
    class="rs-es-first-section"
    aria-live="polite"
    aria-busy="true"
    role="alert"
    aria-label="Your content is loading"
  >
    <div class="row">
      <div class="columns small-12">
        <div
          class="panel rs-wd-s30 rs-wd-m31 rs-h-s4 rs-h-m5 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
        ></div>

        <div class="rs-panel-big rs-bg-c2 clearfix">
          <div
            class="panel rs-wd-s6 rs-wd-m10 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom2 rs-bg-skeleton rs-anim-loading"
          ></div>
          <div class="rs-flex-row rs-flex-middle-medium rs-flex-dir-col-small-only">
            <div class="rs-flex-column rs-flex-shrink">
              <div
                class="panel rs-wd-s16 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom1 rs-bg-skeleton rs-anim-loading"
              ></div>
            </div>
            <div class="rs-flex-column">
              <div
                class="panel rs-wd-s6 rs-wd-m8 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-skeleton rs-anim-loading"
              ></div>
            </div>
          </div>
          <div
            class="panel rs-maxw rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-skeleton rs-anim-loading hide-for-medium-up"
          ></div>
          <div
            class="panel rs-maxw rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-skeleton rs-anim-loading hide-for-medium-up"
          ></div>
          <div
            class="panel rs-maxw rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-skeleton rs-anim-loading"
          ></div>
          <div class="panel rs-bg-grey2 clearfix">
            <div class="rs-flex-row">
              <div class="rs-flex-column rs-flex-shrink">
                <div
                  class="panel rs-wd-s2 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-skeleton rs-anim-loading"
                ></div>
              </div>
              <div class="rs-flex-column">
                <div
                  class="panel rs-wd-s19 rs-wd-m23 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-skeleton rs-anim-loading"
                ></div>
              </div>
            </div>
            <div
              class="panel rs-wd-s19 rs-wd-m23 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-skeleton rs-anim-loading"
            ></div>
          </div>
          <div class="rs-me"></div>
          <div class="rs-flex-row rs-flex-middle-medium rs-flex-dir-col-small-only">
            <div class="rs-flex-column rs-flex-shrink">
              <div
                class="panel rs-wd-s16 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom1 rs-bg-skeleton rs-anim-loading"
              ></div>
            </div>
            <div class="rs-flex-column">
              <div
                class="panel rs-wd-s6 rs-wd-m8 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-skeleton rs-anim-loading"
              ></div>
            </div>
          </div>
          <div class="rs-me"></div>
          <div class="panel rs-bg-grey2 clearfix">
            <div class="rs-flex-row rs-flex-middle">
              <div class="rs-flex-column rs-flex-shrink">
                <div
                  class="panel rs-wd-s2 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-skeleton rs-anim-loading"
                ></div>
              </div>
              <div class="rs-flex-column">
                <div
                  class="panel rs-wd-s19 rs-wd-m23 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-skeleton rs-anim-loading"
                ></div>
              </div>
              <div class="rs-flex-column rs-flex-shrink">
                <div
                  class="panel rs-wd-s5 rs-wd-m6 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom1 rs-bg-skeleton rs-anim-loading"
                ></div>
              </div>
            </div>
            <div
              class="panel rs-wd-s19 rs-wd-m23 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-skeleton rs-anim-loading"
            ></div>
          </div>
          <div class="rs-flex-row rs-flex-dir-col-small-only">
            <div class="rs-flex-column rs-order-m2">
              <div
                class="panel rs-maxw rs-wd-m17 rs-h-s5 rs-no-padding rs-margin-bottom1 rs-bg-skeleton rs-anim-loading"
              ></div>
            </div>
            <div class="rs-flex-column rs-flex-shrink rs-order-m1">
              <div
                class="panel rs-maxw rs-wd-m19 rs-h-s5 rs-no-padding rs-margin-bottom1 rs-bg-skeleton rs-anim-loading"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
